import { gql } from '@apollo/client';

export const VERIFY_USER_EMAIL = gql`
	mutation VerifyUserEmail($token: String!) {
		response: verifyUserEmail(token: $token) {
			error
			success
		}
	}
`;

// verifyEmail(token: String!): Success!
export const VERIFY_USER_EMAIL_V2 = gql`
	mutation VerifyEmail($token: String!) {
		response: verifyEmail(token: $token) {
			success
		}
	}
`;
